import { ActionIcon, Input, Text } from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons-react";
import { memo } from "react";
import { IomData } from "src/pages/Settings/YachtSetup/VesselParticulars/YachtSetup.types";
import { Flex } from "src/styled";

interface Props {
  data: IomData;
  dataKey: string;
  onAddField: (key: string) => void;
  onDeleteField: (key: string, index: number) => void;
  onChangeField: (key: string, index: number, value: string) => void;
}
const IomInput = ({
  data,
  onAddField,
  onChangeField,
  dataKey,
  onDeleteField,
}: Props) => {
  return (
    <Flex direction="column" gap={12} w="100%">
      <Flex justify="space-between">
        <Text size="sm">{data.name}</Text>
        <ActionIcon color="blue" onClick={() => onAddField(dataKey)}>
          <IconPlus />
        </ActionIcon>
      </Flex>
      <Flex direction="column" gap={6} my={4}>
        {data.list.map((item, index) => (
          <Flex key={`${dataKey}-${index}`} gap={5} align="center">
            <Input
              key={`${dataKey}-${index}`}
              value={item}
              onChange={e => onChangeField(dataKey, index, e.target.value)}
              style={{ flex: 1 }}
            />
            <ActionIcon
              color="red"
              onClick={() => onDeleteField(dataKey, index)}>
              <IconTrash />
            </ActionIcon>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};
export default memo(IomInput);
